const ColorServices = {
  getColor(color) {
    switch (color) {
      case "purple":
        return "#6621C0";
      case "purpleMid":
        return "#41157A";
      case "purpleDark":
        return "#360E6B";
      case "turquoise":
        return "#57CFC7";
      case "turquoiseMid":
        return "#1a988f";
      case "peach":
        return "#FFB18F";
      case "text":
        return "#323232";
      case "textGrey":
        return "#5A626C";
      case "white":
        return "#FFFFFF";
      case "black":
        return "#000000";
      case "greyTicketing":
        return "#635B6C";
      case "greyBackground":
        return "#F9F9Fa";
      case "greyPurpleBackground":
        return "#F0EAF9";
      case "greyDarkBackground":
        return "#EEECF0";
      case "divider":
        return "#DEDEDE";
      case "inputBorder":
        return "#8D949E";
      case "footer":
        return "#4E4757";
      case "blue":
        return "#196087";
      case "transparent":
        return "transparent";
      case "blue":
        return "#196097";
      default:
        return "red";
    }
  }
};

export default ColorServices;
